import React from "react";
import styles from '../Styles/jumbotron.css'
import planetImage from '../images/planetImage.jpg';
import Icon from '../images/korlog.jsx';
import kornik from '../images/kornik.svg';

function Jumbotron() {
    return(
        <div className="jumbotron">
            <div className="logoContainer">
                <img src={kornik} className="logo"/>
            </div>
        </div>
    );
}

export default Jumbotron;